import { useState, useEffect } from "react";
import {
    Container,
    Box,
    Paper,
    Typography,
    Tabs,
    Tab,
    Button,
    CircularProgress,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    InputAdornment,
    Modal,
    Card,
    CardContent,
    Grid,
    FormControlLabel,
    Switch
} from "@mui/material";
import Logocolor from "../../../Image/Logo.png";
import { CalendarToday } from "@mui/icons-material";
import {
    Texto, buttonGuardar, buttonCancelar, Input, InputDescripcion, inputFechaGrande, modalStyle,
    SubTitulodos,


} from "../../../Layouts/CustomStyles";
import AddIcon from "@mui/icons-material/Add";
import { useEgresoRME, useGetEgresosRME, useGetCategoriasRME, useEgresoSumaRME, useEgresoProveedoresRME } from "../../../Services/EgresosRME";
import { useGetSucursal } from "../../../Services/Sucursales";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { GiMoneyStack } from "react-icons/gi";
import { CategoriaExpenseIndex } from "../../../Components/RME/expences/Categoria";
import { useUserSuperEmpresa } from "../../../Context/AuthContext";
import { PaginaEgreso } from "../../../Components/RME/expences/IndexExpence";
import { ReporteFinanciero } from "../../../Components/RME/expences/ReporteFinanciero";
import { formatCLP } from "../../../Components/FuncionesGenerales/FormatoCLP";
import { FormatRut } from "../../../Components/FuncionesGenerales/Rut";
import { handleExportarExcelEgresoDetallado } from "../../../Components/RME/excel/egresos/excelEgreso";
import { BsFileEarmarkRuledFill } from "react-icons/bs";

export const EgresoRMEIndex = () => {
    const { Usuario } = useUserSuperEmpresa();
    const [tabIndex, setTabIndex] = useState(0);
    const [aplicarRetencion, setAplicarRetencion] = useState(false);
    const handleTabChange = (event, newValue) => setTabIndex(newValue);
    const {
        getSumaMesActual,
        getSumaMesActualPorBranch
    } = useEgresoSumaRME();
    const {
        proveedores, refetchProveedores
    } = useEgresoProveedoresRME();
    const { categorias, loadingCategorias } = useGetCategoriasRME();
  
    const { egresosrme, refetch } = useGetEgresosRME();
   
    const { crearEgresoRME, descargarExcelExpenses  } = useEgresoRME();
    const { sucursales } = useGetSucursal();
    const [openCrear, setOpenCrear] = useState(false);
    const [openAdvertencia, setOpenAdvertencia] = useState(false);
    const [actualizarTabla, setActualizarTabla] = useState(false);
    const [mostrarNuevoProveedor, setMostrarNuevoProveedor] = useState(false);
    const [nuevoEgreso, setNuevoEgreso] = useState({
        date: "",
        expense_category_id: "",
        description: "",
        amount: "",
        branch_id: "",
        user_id: Usuario?.id,

        campo: "Descripción",
        estado: "",
        origen_documento: "",
        tipo_documento: "",
        otro_tipo_documento: "",
        folio: "",
        fecha_emision: "",
        monto_neto: "",
        iva: "",
        monto_exento: "",
        tipo_retencion: "",
        monto_retenido: "",
        observaciones: "",
        documento_adjunto: null,

        proveedor_id: "",            // selección
        proveedor: {                 // si se crea nuevo
            razon_social: "",
            rut_proveedor: "",

        },

        detalle_pago: {
            medio_pago: "",
            cuenta_bancaria: "",
            otra_cuenta_bancaria: "",
            numero_documento_pago: "",
            fecha_pago: "",
            monto_pagado: "",
            cuotas: []
        }
    });

    const [successAlertOpen, setSuccessAlertOpen] = useState(false);
    const [errorAlertOpen, setErrorAlertOpen] = useState(false);
    const [enviandoAlert, setEnviandoAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [sumaMes, setSumaMes] = useState(null);
    const [loadingSuma, setLoadingSuma] = useState(true);
    const [sumaMesSucursal, setSumaMesSucursal] = useState(null);
    const [loadingSumaMesSucursal, setLoadingSumaMesSucursal] = useState(true);
    const [openDialogExcel, setOpenDialogExcel] = useState(false);
    const [filtroMes, setFiltroMes] = useState("");
    const [filtroAnio, setFiltroAnio] = useState("");
    const [filtroSucursal, setFiltroSucursal] = useState("");
    const [distributions, setDistributions] = useState([]);


    useEffect(() => {
        const fetchSumaMes = async () => {
            try {
                const data = await getSumaMesActual();
                setSumaMes(data);
            } catch (error) {
                console.error("❌ Error al cargar suma mes actual:", error);
            } finally {
                setLoadingSuma(false);
            }
        };

        const fetchSumaMesSucursal = async () => {
            try {
                const data = await getSumaMesActualPorBranch();
                setSumaMesSucursal(data); // 👈 DEBE SER ARRAY
            } catch (error) {
                console.error("❌ Error al cargar sumas por sucursal:", error);
            } finally {
                setLoadingSumaMesSucursal(false);
            }
        }

        fetchSumaMes();
        fetchSumaMesSucursal();
    }, []);

    useEffect(() => {
        if (!nuevoEgreso.detalle_pago?.cuotas?.length) return;

        const totalCuotas = Math.round(
            nuevoEgreso.detalle_pago.cuotas.reduce(
                (acc, cuota) => acc + Number(cuota.monto || 0),
                0
            )
        );

        const ivaPercent = nuevoEgreso.iva ? Number(nuevoEgreso.iva) / 100 : 0;

        let neto =
            ivaPercent > 0 ? Math.round(totalCuotas / (1 + ivaPercent)) : totalCuotas;

        let ivaCalc = ivaPercent > 0 ? totalCuotas - neto : 0;

        let retenido = 0;

        if (aplicarRetencion) {
            retenido = Math.round(totalCuotas * 0.1525);
            neto = totalCuotas - retenido;
        }

        setNuevoEgreso(prev => ({
            ...prev,
            amount: totalCuotas,
            monto_neto: prev.editandoNeto ? prev.monto_neto : prev.monto_neto || neto,
            monto_retenido: retenido,
            iva: ivaCalc,
            actualizandoDesdeCuotas: true
        }));
    }, [nuevoEgreso.detalle_pago.cuotas, aplicarRetencion]);

   const obtenerNombreSucursal = (id) => {
    const suc = sucursales?.find(s => s.id === Number(id));
    return suc ? suc.name : "Sucursal desconocida";
};

    const nombreMes = (numero) => {
        const meses = [
            "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
            "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
        ];
        return meses[numero - 1] || "";
    };



    const handleCrearEgreso = async () => {
        setEnviandoAlert(true);
        const camposFaltantes = [];
  if (!nuevoEgreso.date) camposFaltantes.push("Fecha");
  if (!nuevoEgreso.expense_category_id) camposFaltantes.push("Categoría");
  if (!nuevoEgreso.amount) camposFaltantes.push("Monto");
  if (!nuevoEgreso.branch_id) camposFaltantes.push("Sucursal");
  if (!nuevoEgreso.estado) camposFaltantes.push("Estado");
  if (!nuevoEgreso.origen_documento) camposFaltantes.push("Origen de documento");
  if (!nuevoEgreso.fecha_emision) camposFaltantes.push("Fecha de emisión");
  if (!nuevoEgreso.tipo_documento) camposFaltantes.push("Tipo de documento");

  if (camposFaltantes.length > 0) {
    setErrorAlertOpen(true);
    setAlertMessage(
      `Por favor complete los siguientes campos obligatorios: ${camposFaltantes.join(", ")}`
    );
    setEnviandoAlert(false);
    return; 
  }

        const totalDistribuido = distributions.reduce(
            (sum, d) => sum + Number(d.amount || 0),
            0
        );

        if (totalDistribuido > Number(nuevoEgreso.amount)) {
            setErrorAlertOpen(true);
            setAlertMessage("La suma por sucursal supera el monto bruto");
            setEnviandoAlert(false);
            return;
        }

        try {
            const formData = new FormData();
            const tipoDocumentoFinal =
                nuevoEgreso.tipo_documento === "Otros"
                    ? nuevoEgreso.otro_tipo_documento
                    : nuevoEgreso.tipo_documento;

            const cuentaBancoFinal =
                nuevoEgreso.detalle_pago.cuenta_bancaria === "OTRO"
                    ? nuevoEgreso.detalle_pago.otra_cuenta_bancaria
                    : nuevoEgreso.detalle_pago.cuenta_bancaria;



            // Campos simples
            formData.append("date", nuevoEgreso.date);
            formData.append("expense_category_id", nuevoEgreso.expense_category_id);
            formData.append("description", nuevoEgreso.description);
            formData.append("amount", nuevoEgreso.amount);
            formData.append("branch_id", nuevoEgreso.branch_id);
            formData.append("user_id", nuevoEgreso.user_id);

            // Nuevos campos
            formData.append("campo", nuevoEgreso.campo);
            formData.append("estado", nuevoEgreso.estado);
            formData.append("origen_documento", nuevoEgreso.origen_documento);
            formData.append("tipo_documento", tipoDocumentoFinal);
            formData.append("folio", nuevoEgreso.folio);
            formData.append("fecha_emision", nuevoEgreso.fecha_emision);
            formData.append("monto_neto", nuevoEgreso.monto_neto);
            formData.append("iva", nuevoEgreso.iva);
            formData.append("monto_exento", nuevoEgreso.monto_exento);
            formData.append("tipo_retencion", nuevoEgreso.tipo_retencion);
            formData.append("monto_retenido", nuevoEgreso.monto_retenido);
            formData.append("observaciones", nuevoEgreso.observaciones);

            // Documento adjunto
            if (nuevoEgreso.documento_adjunto) {
                formData.append("documento_adjunto", nuevoEgreso.documento_adjunto);
            }

            // Proveedor
            formData.append("proveedor_id", nuevoEgreso.proveedor_id || "");
            // Laravel espera array -> se envía como "proveedor[nombre]" etc.
            formData.append("proveedor[razon_social]", nuevoEgreso.proveedor.razon_social);
            formData.append("proveedor[rut_proveedor]", nuevoEgreso.proveedor.rut_proveedor);


            // Detalle pago
            formData.append("detalle_pago[medio_pago]", nuevoEgreso.detalle_pago.medio_pago);
            formData.append("detalle_pago[cuenta_bancaria]", cuentaBancoFinal ?? "");
            formData.append("detalle_pago[numero_documento_pago]", nuevoEgreso.detalle_pago.numero_documento_pago);
            formData.append("detalle_pago[fecha_pago]", nuevoEgreso.detalle_pago.fecha_pago);
            formData.append("detalle_pago[monto_pagado]", nuevoEgreso.detalle_pago.monto_pagado);

            // Agregar cuotas al formData si existen
            if (nuevoEgreso.detalle_pago?.cuotas?.length) {
                nuevoEgreso.detalle_pago.cuotas.forEach((cuota, index) => {
                    formData.append(`detalle_pago[cuotas][${index}][numero_cuota]`, cuota.numero);
                    formData.append(`detalle_pago[cuotas][${index}][monto]`, cuota.monto);
                    formData.append(`detalle_pago[cuotas][${index}][interes]`, cuota.interes);
                    formData.append(`detalle_pago[cuotas][${index}][fecha_vencimiento]`, cuota.fecha_vencimiento);
                    formData.append(`detalle_pago[cuotas][${index}][estado]`, cuota.estado);
                });
            }
            //  Distribuciones por sucursal
            distributions.forEach((dist, index) => {
                formData.append(`distributions[${index}][branch_id]`, dist.branch_id);
                formData.append(`distributions[${index}][amount]`, dist.amount);
                formData.append(`distributions[${index}][item]`, dist.item || "");
                formData.append(`distributions[${index}][quantity]`, dist.quantity || "");
                formData.append(`distributions[${index}][unit]`, dist.unit || "");
            });

            await crearEgresoRME(formData);

            setOpenCrear(false);
            setSuccessAlertOpen(true);
            setAlertMessage("Egreso creado correctamente");
            setDistributions([]);
            // Limpiar formulario
            setNuevoEgreso({
                date: "",
                expense_category_id: "",
                description: "",
                amount: "",
                branch_id: "",
                user_id: Usuario?.id,
                campo: "Descripción",
                estado: "",
                origen_documento: "",
                tipo_documento: "",
                otro_tipo_documento: "",
                folio: "",
                fecha_emision: "",
                monto_neto: "",
                iva: "",
                monto_exento: "",
                tipo_retencion: "",
                monto_retenido: "",
                observaciones: "",
                documento_adjunto: null,
                proveedor_id: "",
                proveedor: { nombre: "", rut_proveedor: "", email: "" },
                detalle_pago: { medio_pago: "", cuenta_bancaria: "", numero_documento_pago: "", fecha_pago: "", monto_pagado: "" },

            });

            await refetch();
            await refetchProveedores();
            setActualizarTabla(prev => !prev);
            setEnviandoAlert(false);
        } catch (error) {
            console.error(error);
            setEnviandoAlert(false);
            setErrorAlertOpen(true);
            setAlertMessage("Error al crear egreso");
        }
    };

    const calcularRetencion = () => {
        const bruto = Number(nuevoEgreso.amount) || 0;

        if (bruto > 0) {
            const retenido = Math.round(bruto * 0.1525);
            const netoFinal = bruto - retenido;

            setNuevoEgreso({
                ...nuevoEgreso,
                monto_retenido: retenido,
                monto_neto: netoFinal
            });
        }
    };


    const handleAgregarSucursal = () => {
        // Si es la primera vez que agregan
        if (distributions.length === 0) {
            setDistributions([
                {
                    branch_id: nuevoEgreso.branch_id, // usa la principal
                    amount: "",
                    item: "",
                    quantity: "",
                    unit: ""
                }
            ]);
        } else {
            // Si ya hay una, agrega vacía
            setDistributions([
                ...distributions,
                {
                    branch_id: "",
                    amount: "",
                    item: "",
                    quantity: "",
                    unit: ""
                }
            ]);
        }
    };
    const handleDistributionChange = (index, field, value) => {
        const updated = [...distributions];
        updated[index][field] = value;
        setDistributions(updated);
    };
    const eliminarSucursal = (index) => {
        const updated = distributions.filter((_, i) => i !== index);
        setDistributions(updated);
    };

    const totalDistribuidofinal = distributions.reduce(
        (sum, d) => sum + Number(d.amount || 0),
        0
    );

    const handleDescargarExcel = async () => {
    try {
        setEnviandoAlert(true);

        await descargarExcelExpenses(
            filtroMes,
            filtroAnio,
            filtroSucursal
        );

        setAlertMessage("Excel descargado correctamente ✅");
        setSuccessAlertOpen(true);

    } catch (error) {
        setAlertMessage(error);
        setErrorAlertOpen(true);

    } finally {
        setEnviandoAlert(false);
        setOpenDialogExcel(false)
    }
};
    return (
        <Container maxWidth="xl" sx={{ py: 5 }}>
            <Paper
                elevation={4}
                sx={{
                    p: 4,
                    borderRadius: "20px",
                    background: "linear-gradient(145deg, #ffffff, #f4f6f8)",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.1)"
                }}
            >
                <Box sx={{
                    display: "flex",
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <Box display="flex" alignItems="center" gap={2}>
                        <img
                            src={Logocolor}
                            alt="Logo Clínica Activa"
                            style={{ width: 55, height: 55, objectFit: "contain" }}
                        />
                        <Typography variant="h5" sx={Texto}>
                            Egresos RME
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Button
                            startIcon={< AddCircleOutlineIcon />}
                            variant="contained"
                            sx={{
                                backgroundColor: "#2a8d74",
                                borderRadius: "50px",
                                textTransform: "none",
                                fontFamily: "Poppins",
                            }}
                            onClick={() => {
                                if (!categorias || categorias.length === 0) {
                                    setOpenAdvertencia(true);   // 👈 Mostrar advertencia
                                    return;
                                }
                                setOpenCrear(true);              // 👈 Abrir modal de creación normal
                            }}
                        >
                            Nuevo Egreso RME
                        </Button>

                        <Button
                            startIcon={< BsFileEarmarkRuledFill />}
                            variant="contained"
                            sx={{
                                backgroundColor: "#2a8d74",
                                borderRadius: "50px",
                                textTransform: "none",
                                fontFamily: "Poppins",
                            }}
                            onClick={() => setOpenDialogExcel(true)}
                        >
                            Descargar Egreso RME
                        </Button>



                    </Box>
                </Box>
                <Box mt={5} mb={5}>
                    <Card
                        sx={{
                            width: "50%",
                            backgroundColor: "#ffffff",
                            borderRadius: 3,
                            boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
                            transition: "transform 0.2s, box-shadow 0.2s",
                        }}
                    >
                        <CardContent
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <Box
                                sx={{
                                    width: "80%",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "flex-start",
                                    gap: 1,
                                }}
                            >
                                <Typography
                                    variant="h4"
                                    fontWeight={400}
                                    sx={{ fontFamily: "Poppins", color: "#585857" }}
                                >
                                    {loadingSuma
                                        ? < CircularProgress />
                                        : new Intl.NumberFormat("es-CL", {
                                            style: "currency",
                                            currency: "CLP",
                                            minimumFractionDigits: 0,
                                        }).format(sumaMes?.total || 0)
                                    }
                                </Typography>

                                <Typography
                                    variant="h6"
                                    fontWeight={500}
                                    sx={{ fontFamily: "Poppins", color: "#585857" }}
                                >
                                    Total{" "}
                                    <Box component="span" sx={{ color: "#2a8d74", fontWeight: 500 }}>
                                        {sumaMes
                                            ? `Monto Mes ${nombreMes(sumaMes.mes)} ${sumaMes.año}`
                                            : ""}
                                    </Box>
                                </Typography>
                            </Box>

                            <Box>
                                <GiMoneyStack size={60} color="#5cd09aff" />
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
                <Box mt={5} mb={5}>
                    {!loadingSumaMesSucursal && sumaMesSucursal && (
                        <Typography
                            variant="body1"
                            fontWeight={500}
                            sx={{ fontFamily: "Poppins", mb: 3, color: "#2a8d74" }}
                        >
                            Reporte financiero por sucursal —
                            {` ${nombreMes(sumaMesSucursal.mes)} ${sumaMesSucursal.año}`}
                        </Typography>
                    )}

                    <Grid container spacing={3}>
                        {loadingSumaMesSucursal ? (
                            <Typography> < CircularProgress /> </Typography>
                        ) : (
                            sumaMesSucursal?.data?.map((item) => (
                                <Grid key={item.branch_id} size={{ xs: 12, sm: 6, md: 4 }}>
                                    <Card
                                        sx={{
                                            width: "100%",
                                            backgroundColor: "#ffffff",
                                            borderRadius: 3,
                                            boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
                                            transition: "transform 0.2s, box-shadow 0.2s",
                                            "&:hover": {
                                                transform: "scale(1.02)",
                                                boxShadow: "0px 6px 14px rgba(42, 103, 69, 0.5)",
                                            },
                                        }}
                                    >
                                        <CardContent
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: "80%",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: 1,
                                                }}
                                            >
                                                <Typography
                                                    variant="body1"
                                                    fontWeight={500}
                                                    sx={{
                                                        fontFamily: "Poppins",
                                                        color: "#2a8d74",
                                                    }}
                                                >
                                                    {obtenerNombreSucursal(item.branch_id)}
                                                </Typography>

                                                <Typography
                                                    variant="h6"
                                                    fontWeight={400}
                                                    sx={{ fontFamily: "Poppins", color: "#585857" }}
                                                >
                                                    {new Intl.NumberFormat("es-CL", {
                                                        style: "currency",
                                                        currency: "CLP",
                                                        minimumFractionDigits: 0,
                                                    }).format(item.total)}
                                                </Typography>

                                                <Typography
                                                    variant="body1"
                                                    fontWeight={500}
                                                    sx={{ fontFamily: "Poppins", color: "#585857" }}
                                                >
                                                    Total{" "}
                                                    <Box component="span" sx={{ color: "#2a8d74", fontWeight: 500 }}>
                                                        Mes {nombreMes(item.mes)} {item.año}
                                                    </Box>
                                                </Typography>
                                            </Box>

                                            <GiMoneyStack size={50} color="#5cd09aff" />
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))
                        )}
                    </Grid>
                </Box>
                <Box sx={{ mt: 5 }}>
                    <Tabs
                        value={tabIndex}
                        onChange={handleTabChange}
                        textColor="primary"
                        indicatorColor="primary"
                        variant="scrollable"   // 👈 evita que se estiren a todo el ancho
                        scrollButtons={false}
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: "#6fd385ff", // 👈 mismo verde del tab activo
                                height: "3px",             // 👈 grosor de la línea
                                borderRadius: "2px",       // 👈 opcional, línea más suave
                            },
                        }}
                        sx={{
                            "& .MuiTab-root": {
                                minWidth: "auto",
                                px: 2,
                                margin: '0px 5px',
                                backgroundColor: "#b2e9be68",
                                textTransform: "none",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                borderRadius: "8px 8px 0 0", // 👈 esquinas redondeadas arriba (opcional)
                            },
                            "& .Mui-selected": {
                                backgroundColor: "#2a8d74", // 👈 verde oscuro
                                color: "#fff !important",   // 👈 letras blancas
                            },
                        }}>
                        <Tab label="Egresos RME" />
                        <Tab label="Categoria Egresos RME" />
                        <Tab label="Reporte Financiero RME" />
                    </Tabs>

                    {tabIndex === 0 && (
                        <>

                            <PaginaEgreso actualizarTabla={actualizarTabla} />
                        </>
                    )}

                    {tabIndex === 1 && (
                        <>
                            <CategoriaExpenseIndex />
                        </>
                    )}
                    {tabIndex === 2 && (
                        <>
                            <ReporteFinanciero />
                        </>
                    )}
                </Box>
            </Paper>

            <Dialog open={openCrear} onClose={() => setOpenCrear(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={Texto}>Nuevo Egreso RME</DialogTitle>
                <Typography variant="subtitle2" sx={{ fontFamily: 'Poppins', fontWeight: '400', color: '#585857', p: 3, textAlign: 'justify' }}>
                    Completa la información detallada del egreso que deseas registrar.
                    Si no dispones de algunos datos o el detalle es breve, puedes dejar
                    los campos vacíos o ingresar 0 cuando corresponda.
                </Typography>

                <DialogContent dividers>
                    <Box display="flex" flexDirection="column" gap={2}>

                        {/* SELECT CATEGORÍA */}
                        <FormControl fullWidth sx={Input}>
                            <InputLabel>Tipo</InputLabel>
                            <Select
                                value={nuevoEgreso.expense_category_id}
                                label="Tipo"
                                onChange={(e) =>
                                    setNuevoEgreso({
                                        ...nuevoEgreso,
                                        expense_category_id: Number(e.target.value),
                                    })
                                }
                            >
                                {loadingCategorias && (
                                    <MenuItem disabled>Cargando categorías...</MenuItem>
                                )}

                                {!loadingCategorias &&
                                    categorias?.map((cat) => (
                                        <MenuItem key={cat.id} value={cat.id}>
                                            {cat.name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>

                        <FormControl fullWidth sx={Input}>
                            <InputLabel>Estado</InputLabel>
                            <Select
                                value={nuevoEgreso.estado}
                                label="Estado"
                                onChange={(e) =>
                                    setNuevoEgreso({
                                        ...nuevoEgreso,
                                        estado: e.target.value
                                    })
                                }
                            >
                                <MenuItem value="Registrado">Registrado</MenuItem>
                                <MenuItem value="Pagado">Pagado</MenuItem>
                                <MenuItem value="Anulado">Anulado</MenuItem>
                            </Select>
                        </FormControl>

                        <Box>
                            {/* SELECT SUCURSAL */}
                            <FormControl fullWidth sx={Input}>
                                <InputLabel>Sucursal</InputLabel>
                                <Select
                                    value={nuevoEgreso.branch_id}
                                    label="Sucursal"
                                    onChange={(e) =>
                                        setNuevoEgreso({
                                            ...nuevoEgreso,
                                            branch_id: Number(e.target.value),
                                        })
                                    }
                                >
                                    {sucursales?.map((s) => (
                                        <MenuItem key={s.id} value={s.id}>
                                            {s.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            {/* FECHA */}
                            <TextField
                                label="Fecha"
                                type="date"
                                value={nuevoEgreso.date}
                                onChange={(e) =>
                                    setNuevoEgreso({
                                        ...nuevoEgreso,
                                        date: e.target.value,
                                    })
                                }
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                sx={{ ...inputFechaGrande, mt: 2, mb: 2 }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <CalendarToday />
                                        </InputAdornment>
                                    ),
                                }}
                            />

                            {/* DESCRIPCIÓN */}
                            <TextField
                                label="Descripción"
                                value={nuevoEgreso.description}
                                onChange={(e) =>
                                    setNuevoEgreso({
                                        ...nuevoEgreso,
                                        description: e.target.value,
                                    })
                                }
                                fullWidth
                                multiline
                                rows={2}
                                sx={InputDescripcion}
                            />

                        </Box>
                        <Box sx={{ borderRadius: 1, border: '1px solid #585857', p: 2 }}>
                            <Typography variant="subtitle1" sx={SubTitulodos}>  Información del Documento Tributario</Typography>
                            <Box mt={3}>

                                <Box mt={2}>
                                    <FormControl fullWidth sx={Input}>
                                        <InputLabel>Origen del Documento</InputLabel>
                                        <Select
                                            value={nuevoEgreso.origen_documento}
                                            label="origen documento"
                                            onChange={(e) =>
                                                setNuevoEgreso({
                                                    ...nuevoEgreso,
                                                    origen_documento: e.target.value
                                                })
                                            }
                                        >
                                            <MenuItem value="Manual">Manual</MenuItem>
                                            <MenuItem value="Emitido">Emitido</MenuItem>
                                            <MenuItem value="Recibido">Recibido</MenuItem>

                                        </Select>
                                    </FormControl>
                                </Box>
                                <Box mt={2}>
                                    <FormControl fullWidth sx={Input}>
                                        <InputLabel>Tipo Documento</InputLabel>
                                        <Select
                                            value={nuevoEgreso.tipo_documento}
                                            label="Tipo Documento"
                                            onChange={(e) =>
                                                setNuevoEgreso({
                                                    ...nuevoEgreso,
                                                    tipo_documento: e.target.value,
                                                    // limpiamos si cambia
                                                    otro_tipo_documento:
                                                        e.target.value === "Otros"
                                                            ? nuevoEgreso.otro_tipo_documento
                                                            : "",
                                                })
                                            }
                                        >
                                            <MenuItem value="Factura Electrónica">Factura Electrónica</MenuItem>
                                            <MenuItem value="Factura Exenta">Factura Exenta</MenuItem>
                                            <MenuItem value="Boleta Electrónica">Boleta Electrónica</MenuItem>
                                            <MenuItem value="Boleta Exenta">Boleta Exenta</MenuItem>
                                            <MenuItem value="Boleta Honorarios">Boleta Honorarios</MenuItem>
                                            <MenuItem value="Nota de Crédito Electrónica">Nota de Crédito</MenuItem>
                                            <MenuItem value="Nota de Débito Electrónica">Nota de Débito</MenuItem>
                                            <MenuItem value="Liquidación">Liquidación</MenuItem>
                                            <MenuItem value="Guía de Despacho">Guía de Despacho</MenuItem>
                                            <MenuItem value="Orden de Compra">Orden de Compra</MenuItem>

                                            {/* ⭐ ESTA ES LA OPCIÓN QUE ACTIVA EL INPUT */}
                                            <MenuItem value="Otros">Otros</MenuItem>
                                        </Select>
                                    </FormControl>

                                    {nuevoEgreso.tipo_documento === "Otros" && (
                                        <TextField
                                            label="Especificar documento"
                                            fullWidth
                                            sx={{ mt: 2, ...Input }}
                                            value={nuevoEgreso.otro_tipo_documento}
                                            onChange={(e) =>
                                                setNuevoEgreso({
                                                    ...nuevoEgreso,
                                                    otro_tipo_documento: e.target.value,
                                                })
                                            }
                                        />
                                    )}

                                </Box>
                                <Box mt={2}>
                                    <TextField
                                        label="Folio"
                                        value={nuevoEgreso.folio}
                                        onChange={(e) => setNuevoEgreso({ ...nuevoEgreso, folio: e.target.value })}
                                        fullWidth
                                        sx={Input}
                                    />


                                </Box>
                                <Box mt={2}>
                                    <TextField
                                        label="Fecha de Emisión"
                                        type="date"
                                        value={nuevoEgreso.fecha_emision}
                                        onChange={(e) => setNuevoEgreso({ ...nuevoEgreso, fecha_emision: e.target.value })}
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        sx={{ ...inputFechaGrande, mt: 2, mb: 2 }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <CalendarToday />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                            </Box>
                        </Box>
              <Box>
  <Box sx={{ borderRadius: 1, border: "1px solid #585857", p: 2 }}>
    <Typography variant="subtitle1" sx={SubTitulodos}>
      Información del Proveedor
    </Typography>

    <Box mt={2}>
      {/* 🔹 Botón para mostrar/ocultar el bloque de proveedor */}
      <Button
        sx={{ ...buttonGuardar, mt: 2 }}
        onClick={() => setMostrarNuevoProveedor((prev) => !prev)}
      >
        {mostrarNuevoProveedor ? "Ocultar formulario de proveedor" : "Agregar proveedor"}
      </Button>

      {/* 🔹 Todo el bloque de proveedor solo se muestra si el usuario hizo click */}
      {mostrarNuevoProveedor && (
        <Box mt={2}>
          {/* 🔹 Select para elegir proveedor existente */}
          <FormControl fullWidth sx={Input}>
            <InputLabel>Proveedor</InputLabel>
            <Select
              value={nuevoEgreso.proveedor_id}
              label="Proveedor"
              onChange={(e) => {
                const value = e.target.value;
                setNuevoEgreso((prev) => ({
                  ...prev,
                  proveedor_id: value,
                  proveedor:
                    value !== ""
                      ? { razon_social: "", rut_proveedor: "", email: "" }
                      : prev.proveedor,
                }));
              }}
            >
              <MenuItem value="">Sin proveedor</MenuItem>
              {proveedores?.map((p) => (
                <MenuItem key={p.id} value={p.id}>
                  {p.razon_social} — {p.rut_proveedor}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* 🔹 Campos para crear un nuevo proveedor solo si no seleccionó uno existente */}
          {!nuevoEgreso.proveedor_id && (
            <Box mt={2}>
              <Typography variant="subtitle1" sx={SubTitulodos}>
                Nuevo Proveedor
              </Typography>
              <Box mt={1}>
                <TextField
                  label="Razón Social"
                  value={nuevoEgreso.proveedor.razon_social}
                  onChange={(e) =>
                    setNuevoEgreso({
                      ...nuevoEgreso,
                      proveedor: { ...nuevoEgreso.proveedor, razon_social: e.target.value },
                    })
                  }
                  fullWidth
                  sx={Input}
                />
              </Box>
              <Box mt={1}>
                <TextField
                  label="RUT del Proveedor"
                  value={nuevoEgreso.proveedor.rut_proveedor}
                  onChange={(e) => {
                    const rutFormateado = FormatRut(e.target.value);
                    setNuevoEgreso({
                      ...nuevoEgreso,
                      proveedor: { ...nuevoEgreso.proveedor, rut_proveedor: rutFormateado },
                    });
                  }}
                  fullWidth
                  sx={Input}
                />
              </Box>
            </Box>
          )}
        </Box>
      )}
    </Box>
  </Box>
</Box>

                        <Box sx={{ borderRadius: 1, border: "1px solid #585857", p: 2 }}>
                            <Typography variant="subtitle1" sx={SubTitulodos}>
                                Información del Monto
                            </Typography>

                            <Box mt={2}>

                                {/* Monto Bruto */}
                                <TextField
                                    label="Monto"
                                    value={formatCLP(nuevoEgreso.amount)}
                                    onChange={(e) => {
                                        const cleanValue = Number(e.target.value.replace(/\D/g, ""));
                                        const ivaPercent = nuevoEgreso.iva ? Number(nuevoEgreso.iva) / 100 : 0;

                                        // Calcular neto base (sin retención)
                                        let neto = ivaPercent > 0
                                            ? Math.round(cleanValue / (1 + ivaPercent))
                                            : cleanValue;

                                        let ivaCalc = cleanValue - neto;

                                        // 👇 Si hay retención activa
                                        let retenido = 0;
                                        if (aplicarRetencion) {
                                            retenido = Math.round(cleanValue * 0.1525);
                                            neto = cleanValue - retenido; // 👈 neto final
                                        }

                                        setNuevoEgreso({
                                            ...nuevoEgreso,
                                            amount: cleanValue,
                                            monto_neto: neto,
                                            monto_retenido: retenido,
                                            iva: ivaPercent > 0 ? ivaCalc : 0
                                        });
                                    }}
                                    fullWidth
                                    sx={Input}
                                />

                                {/* IVA */}
                                <Box mt={1} mb={1}>
                                    <TextField
                                        label="IVA % (19 = 19%)"
                                        value={nuevoEgreso.iva}
                                        onChange={(e) => {
                                            const cleanValue = Number(e.target.value.replace(/\D/g, "")); // solo 19, 10, etc.

                                            const ivaPercent = cleanValue / 100;
                                            const amount = Number(nuevoEgreso.amount);

                                            // Recalcular Neto
                                            const neto = ivaPercent > 0 ? Math.round(amount / (1 + ivaPercent)) : amount;
                                            const ivaCalc = amount - neto;

                                            setNuevoEgreso({
                                                ...nuevoEgreso,
                                                iva: cleanValue,
                                                monto_neto: neto,
                                            });
                                        }}
                                        fullWidth
                                        sx={Input}
                                    />
                                </Box>

                                {/* Monto Neto */}
                              <TextField
                                label="Monto Neto"
                                value={nuevoEgreso.monto_neto ? formatCLP(nuevoEgreso.monto_neto) : ""}
                                onFocus={() => setNuevoEgreso(prev => ({ ...prev, editandoNeto: true }))}
                                onBlur={() => setNuevoEgreso(prev => ({ ...prev, editandoNeto: false }))}
                                onChange={(e) => {
                                    const cleanValue = Number(e.target.value.replace(/\D/g, "")) || 0;

                                    // Solo actualizamos el neto, sin tocar amount ni iva
                                    setNuevoEgreso(prev => ({
                                    ...prev,
                                    monto_neto: cleanValue
                                    }));
                                }}
                                fullWidth
                                sx={Input}
                                />
                                {/* Monto Exento */}
                                <Box mt={1} mb={1}>
                                    <TextField
                                        label="Monto Exento"
                                        value={formatCLP(nuevoEgreso.monto_exento)}
                                        onChange={(e) => {
                                            const cleanValue = e.target.value.replace(/\D/g, "");
                                            setNuevoEgreso({
                                                ...nuevoEgreso,
                                                monto_exento: cleanValue,
                                            });
                                        }}
                                        fullWidth
                                        sx={Input}
                                    />
                                </Box>

                            </Box>
                        </Box>
                        <Box sx={{ borderRadius: 1, border: "1px solid #585857", p: 2 }}>
                            <Typography variant="subtitle1" sx={SubTitulodos}>
                                Información de retención
                            </Typography>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={aplicarRetencion}
                                        onChange={(e) => {
                                            const checked = e.target.checked;
                                            setAplicarRetencion(checked);

                                            if (checked) {
                                                calcularRetencion();
                                            } else {
                                                setNuevoEgreso({
                                                    ...nuevoEgreso,
                                                    monto_retenido: 0,
                                                    tipo_retencion: ""
                                                });
                                            }
                                        }}
                                    />
                                }
                                label="¿Aplicar Retención 15,25%?"
                                sx={{
                                    "& .MuiFormControlLabel-label": {
                                        fontFamily: "Poppins",
                                        color: "#22324A",
                                        fontWeight: 500,
                                        fontSize: "0.95rem"
                                    }
                                }}
                            />
                            {aplicarRetencion && (
                                <>
                                    <TextField
                                        label="Tipo de Retención"
                                        value={nuevoEgreso.tipo_retencion}
                                        onChange={(e) =>
                                            setNuevoEgreso({
                                                ...nuevoEgreso,
                                                tipo_retencion: e.target.value,
                                            })
                                        }
                                        fullWidth
                                        sx={{ ...Input, mt: 1, mb: 1 }}
                                    />

                                    <TextField
                                        label="Monto Retenido"
                                        value={formatCLP(nuevoEgreso.monto_retenido)}
                                        fullWidth
                                        sx={Input}
                                        InputProps={{
                                            readOnly: true // 👈 importante
                                        }}
                                    />
                                </>
                            )}
                        </Box>
                        <Box sx={{ borderRadius: 1, border: "1px solid #585857", p: 2 }}>
                            <Typography variant="subtitle1" sx={SubTitulodos}>
                                Información del Monto por sucursal
                            </Typography>

                            <Button
                                variant="outlined"
                                startIcon={<AddIcon />}
                                onClick={handleAgregarSucursal}
                                sx={buttonGuardar}
                            >
                                Agregar sucursal
                            </Button>

                            {distributions.map((dist, index) => (
                                <Box key={index} sx={{ mt: 2, border: "1px solid #ccc", p: 2, borderRadius: 1 }}>

                                    {/* Sucursal */}
                                    <FormControl fullWidth sx={Input}>
                                        <InputLabel>Sucursal</InputLabel>
                                        <Select
                                            value={dist.branch_id}
                                            label="Sucursal"
                                            onChange={(e) =>
                                                handleDistributionChange(index, "branch_id", Number(e.target.value))
                                            }
                                        >
                                            {sucursales?.map((s) => (
                                                <MenuItem key={s.id} value={s.id}>
                                                    {s.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                    {/* Monto */}

                                    <Box mt={1} mb={1}>
                                        <TextField
                                            fullWidth
                                            label="Monto"
                                            sx={Input}
                                            value={formatCLP(dist.amount)}
                                            onChange={(e) => {
                                                // Quitamos todo lo que no sea número
                                                const rawValue = e.target.value.replace(/\D/g, "");
                                                handleDistributionChange(index, "amount", rawValue);
                                            }}
                                        />
                                    </Box>

                                    <Box mt={1} mb={1}>
                                        <TextField
                                            fullWidth
                                            label="Item"
                                            sx={Input}
                                            value={dist.item}
                                            onChange={(e) =>
                                                handleDistributionChange(index, "item", e.target.value)
                                            }
                                        />
                                    </Box>

                                    <Box mt={1} mb={1}>
                                        <TextField
                                            fullWidth
                                            label="Cantidad"
                                            type="number"
                                            sx={Input}
                                            value={dist.quantity}
                                            onChange={(e) =>
                                                handleDistributionChange(index, "quantity", e.target.value)
                                            }
                                        />
                                    </Box>

                                    <Box mt={1} mb={1}>
                                        <TextField
                                            fullWidth
                                            label="Unidad"
                                            sx={Input}
                                            value={dist.unit}
                                            onChange={(e) =>
                                                handleDistributionChange(index, "unit", e.target.value)
                                            }
                                        />
                                    </Box>

                                    <Button
                                        color="error"
                                        onClick={() => eliminarSucursal(index)}
                                        sx={buttonCancelar}
                                    >
                                        Eliminar
                                    </Button>
                                </Box>
                            ))}
                            <Typography sx={{ ...SubTitulodos, mt: 3 }}>
                                Total distribuido: {formatCLP(totalDistribuidofinal)}
                            </Typography>
                        </Box>
                        <Box sx={{ borderRadius: 1, border: "1px solid #585857", p: 2 }}>
                            <Typography variant="subtitle1" sx={SubTitulodos}>
                                Información del detalle de pago
                            </Typography>

                            <Box>
                                <FormControl fullWidth sx={{ ...Input, mt: 1, mb: 1 }}>
                                    <InputLabel>Medio de Pago</InputLabel>
                                    <Select
                                        label="Medio de Pago"
                                        value={nuevoEgreso.detalle_pago.medio_pago}
                                        onChange={(e) =>
                                            setNuevoEgreso({
                                                ...nuevoEgreso,
                                                detalle_pago: {
                                                    ...nuevoEgreso.detalle_pago,
                                                    medio_pago: e.target.value,
                                                    medio_pago_personalizado:
                                                        e.target.value === "Otro medio de pago" ? "" : null,
                                                },
                                            })
                                        }
                                    >
                                        <MenuItem value="Transferencia">Transferencia</MenuItem>
                                        <MenuItem value="Cheque">Cheque</MenuItem>
                                        <MenuItem value="Efectivo">Efectivo</MenuItem>
                                        <MenuItem value="Débito">Débito</MenuItem>
                                        <MenuItem value="Crédito">Crédito</MenuItem>
                                        <MenuItem value="Otro medio de pago">Otro medio de pago</MenuItem>
                                    </Select>
                                </FormControl>

                                {nuevoEgreso.detalle_pago.medio_pago === "Otro medio de pago" && (
                                    <TextField
                                        label="Especifique el medio de pago"
                                        fullWidth
                                        sx={{ ...Input, mb: 2 }}
                                        value={nuevoEgreso.detalle_pago.medio_pago_personalizado || ""}
                                        onChange={(e) =>
                                            setNuevoEgreso({
                                                ...nuevoEgreso,
                                                detalle_pago: {
                                                    ...nuevoEgreso.detalle_pago,
                                                    medio_pago_personalizado: e.target.value,
                                                },
                                            })
                                        }
                                    />
                                )}

                            </Box>
                            {nuevoEgreso.detalle_pago.medio_pago === "Crédito" && (
                                <Box sx={{ border: "1px solid #aaa", borderRadius: 1, p: 2, mt: 2, mb: 3 }}>
                                    <Typography variant="subtitle1" sx={SubTitulodos}>
                                        Detalle de Cuotas
                                    </Typography>

                                    {/* Día de vencimiento */}
                                    <TextField
                                        label="Día de vencimiento"
                                        type="number"
                                        value={nuevoEgreso.detalle_pago.dia_vencimiento || ""}
                                        onChange={(e) =>
                                            setNuevoEgreso({
                                                ...nuevoEgreso,
                                                detalle_pago: { ...nuevoEgreso.detalle_pago, dia_vencimiento: e.target.value },
                                            })
                                        }
                                        fullWidth
                                        sx={{ ...Input, mt: 1, mb: 1 }}
                                    />

                                    {/* Año Inicial */}
                                    <FormControl fullWidth sx={{ ...Input, mt: 1, mb: 1 }}>
                                        <InputLabel>Año Inicial</InputLabel>
                                        <Select
                                            value={nuevoEgreso.detalle_pago.anio_inicial ?? new Date().getFullYear()}
                                            onChange={(e) =>
                                                setNuevoEgreso({
                                                    ...nuevoEgreso,
                                                    detalle_pago: {
                                                        ...nuevoEgreso.detalle_pago,
                                                        anio_inicial: Number(e.target.value),
                                                    },
                                                })
                                            }
                                        >
                                            {Array.from({ length: 10 }, (_, i) => {
                                                const year = new Date().getFullYear() - 5 + i;
                                                return <MenuItem key={year} value={year}>{year}</MenuItem>;
                                            })}
                                        </Select>
                                    </FormControl>

                                    {/* Mes Inicial */}
                                    <FormControl fullWidth sx={{ ...Input, mt: 1, mb: 1 }}>
                                        <InputLabel>Mes Inicial</InputLabel>
                                        <Select
                                            value={nuevoEgreso.detalle_pago.mes_inicial ?? new Date().getMonth()}
                                            onChange={(e) =>
                                                setNuevoEgreso({
                                                    ...nuevoEgreso,
                                                    detalle_pago: { ...nuevoEgreso.detalle_pago, mes_inicial: Number(e.target.value) },
                                                })
                                            }
                                        >
                                            {[
                                                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                                                "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
                                            ].map((mes, idx) => (
                                                <MenuItem key={idx} value={idx}>{mes}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                    {/* Monto Total */}
                                    <TextField
                                        label="Monto Total"
                                        value={nuevoEgreso.detalle_pago.monto_total || ""}
                                        onChange={(e) =>
                                            setNuevoEgreso({
                                                ...nuevoEgreso,
                                                detalle_pago: { ...nuevoEgreso.detalle_pago, monto_total: e.target.value },
                                            })
                                        }
                                        fullWidth
                                        sx={{ ...Input, mt: 1, mb: 1 }}
                                    />

                                    {/* Interés */}
                                    <TextField
                                        label="Interés (%)"
                                        value={nuevoEgreso.detalle_pago.interes || ""}
                                        onChange={(e) =>
                                            setNuevoEgreso({
                                                ...nuevoEgreso,
                                                detalle_pago: { ...nuevoEgreso.detalle_pago, interes: e.target.value },
                                            })
                                        }
                                        fullWidth
                                        sx={{ ...Input, mt: 1, mb: 1 }}
                                    />

                                    {/* Número de cuotas */}
                                    <TextField
                                        label="Número de Cuotas"
                                        type="number"
                                        value={nuevoEgreso.detalle_pago.num_cuotas || ""}
                                        onChange={(e) => {
                                            const num = Number(e.target.value);
                                            if (!num || num <= 0) return;

                                            // Datos base
                                            const totalConInteres = Number(
                                                String(nuevoEgreso.detalle_pago.monto_total || 0).replace(/\D/g, "")
                                            );
                                            const cuotaBase = Math.floor(totalConInteres / num);
                                            const resto = totalConInteres - cuotaBase * num;

                                            const dia = Number(nuevoEgreso.detalle_pago.dia_vencimiento) || new Date().getDate();
                                            const mesInicial = Number(nuevoEgreso.detalle_pago.mes_inicial ?? new Date().getMonth());
                                            const anioInicial = Number(nuevoEgreso.detalle_pago.anio_inicial ?? new Date().getFullYear());

                                            // Interés visual fijo
                                            const interesMostrar = Number(nuevoEgreso.detalle_pago.interes) || 0;

                                            // Generar cuotas
                                            const cuotas = Array.from({ length: num }, (_, idx) => {
                                                let mes = mesInicial + idx;
                                                let anio = anioInicial + Math.floor(mes / 12);
                                                mes = mes % 12;

                                                const diasEnMes = new Date(anio, mes + 1, 0).getDate();
                                                const diaFinal = Math.min(dia, diasEnMes);
                                                const fecha = new Date(anio, mes, diaFinal);

                                                let montoCuota = cuotaBase;
                                                if (idx === num - 1) montoCuota += resto;

                                                return {
                                                    numero: idx + 1,
                                                    monto: montoCuota,
                                                    interes: interesMostrar,
                                                    fecha_vencimiento: fecha.toISOString().split("T")[0],
                                                    estado: "Pendiente",
                                                };
                                            });

                                            setNuevoEgreso(prev => ({
                                                ...prev,
                                                detalle_pago: {
                                                    ...prev.detalle_pago,
                                                    num_cuotas: num,
                                                    cuotas,
                                                },
                                            }));
                                        }}
                                        fullWidth
                                        sx={{ ...Input, mt: 1, mb: 2 }}
                                    />

                                    {/* Mostrar cuotas */}
                                    {nuevoEgreso.detalle_pago.cuotas?.length > 0 && (
                                        <Box>
                                            {nuevoEgreso.detalle_pago.cuotas.map((cuota, idx) => (
                                                <Box
                                                    key={idx}
                                                    sx={{
                                                        display: "grid",
                                                        gridTemplateColumns: "1fr 1.5fr 1fr 1.5fr",
                                                        gap: 1,
                                                        alignItems: "center",
                                                        mb: 1,
                                                    }}
                                                >
                                                    <TextField label="N° Cuota" value={cuota.numero} disabled fullWidth sx={Input} />
                                                    <TextField label="Monto" value={formatCLP(cuota.monto)} disabled fullWidth sx={Input} />
                                                    <TextField label="Interés (%)" value={cuota.interes} disabled fullWidth sx={Input} />
                                                    <TextField label="Fecha Vencimiento" value={cuota.fecha_vencimiento} disabled fullWidth sx={Input} />
                                                </Box>
                                            ))}
                                        </Box>
                                    )}
                                </Box>
                            )}
                            <FormControl fullWidth sx={Input}>
                                <InputLabel>Cuenta / Banco</InputLabel>

                                <Select
                                    label="Cuenta / Banco"
                                    value={nuevoEgreso.detalle_pago.cuenta_bancaria}
                                    onChange={(e) =>
                                        setNuevoEgreso({
                                            ...nuevoEgreso,
                                            detalle_pago: {
                                                ...nuevoEgreso.detalle_pago,
                                                cuenta_bancaria: e.target.value,
                                                otra_cuenta_bancaria: "",
                                            },
                                        })
                                    }
                                >
                                    <MenuItem value="Banco Estado">Banco Estado</MenuItem>
                                    <MenuItem value="Banco Chile">Banco Chile</MenuItem>
                                    <MenuItem value="Santander">Santander</MenuItem>
                                    <MenuItem value="BCI">BCI</MenuItem>
                                    <MenuItem value="Banco Itaú">Banco Itaú</MenuItem>
                                    <MenuItem value="Scotiabank">Scotiabank</MenuItem>
                                    <MenuItem value="Banco Falabella">Banco Falabella</MenuItem>
                                    <MenuItem value="Banco Security">Banco Security</MenuItem>
                                    <MenuItem value="Banco Ripley">Banco Ripley</MenuItem>

                                    <MenuItem value="OTRO">Otro banco</MenuItem>
                                </Select>

                                {nuevoEgreso.detalle_pago.cuenta_bancaria === "OTRO" && (
                                    <TextField
                                        label="Especifique el banco"
                                        value={nuevoEgreso.detalle_pago.otra_cuenta_bancaria}
                                        onChange={(e) =>
                                            setNuevoEgreso({
                                                ...nuevoEgreso,
                                                detalle_pago: {
                                                    ...nuevoEgreso.detalle_pago,
                                                    otra_cuenta_bancaria: e.target.value,
                                                },
                                            })
                                        }
                                        fullWidth
                                        sx={{ mt: 1 }}
                                    />
                                )}
                            </FormControl>


                            <TextField
                                label="N° Documento"
                                value={nuevoEgreso.detalle_pago.numero_documento_pago}
                                onChange={(e) =>
                                    setNuevoEgreso({
                                        ...nuevoEgreso,
                                        detalle_pago: {
                                            ...nuevoEgreso.detalle_pago,
                                            numero_documento_pago: e.target.value,
                                        },
                                    })
                                }
                                fullWidth
                                sx={{ ...Input, mt: 1, mb: 2 }}
                            />

                            <TextField
                                label="Fecha Pago"
                                type="date"
                                value={nuevoEgreso.detalle_pago.fecha_pago}
                                onChange={(e) =>
                                    setNuevoEgreso({
                                        ...nuevoEgreso,
                                        detalle_pago: { ...nuevoEgreso.detalle_pago, fecha_pago: e.target.value },
                                    })
                                }
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                sx={inputFechaGrande}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <CalendarToday />
                                        </InputAdornment>
                                    ),
                                }}
                            />

                            <TextField
                                label="Monto Pagado"
                                value={formatCLP(nuevoEgreso.detalle_pago.monto_pagado)}
                                onChange={(e) => {
                                    const rawValue = e.target.value.replace(/\D/g, ""); // solo números

                                    setNuevoEgreso({
                                        ...nuevoEgreso,
                                        detalle_pago: {
                                            ...nuevoEgreso.detalle_pago,
                                            monto_pagado: rawValue,
                                        },
                                    });
                                }}
                                fullWidth
                                sx={{ ...Input, mt: 1, mb: 2 }}
                            />

                        </Box>


                        <Box sx={{ borderRadius: 1, border: "1px solid #585857", p: 2 }}>
                            <Typography variant="subtitle1" sx={SubTitulodos}>
                                Detalle ( opcional documento)
                            </Typography>

                            <Box mb={2}>
                                <Button component="label">
                                    Subir Documento PDF
                                    <input
                                        type="file"
                                        accept="application/pdf"
                                        hidden
                                        onChange={(e) =>
                                            setNuevoEgreso({
                                                ...nuevoEgreso,
                                                documento_adjunto: e.target.files[0] // <- debe ser un File
                                            })
                                        }
                                    />
                                </Button>


                            </Box>


                            <Box>
                                <TextField
                                    label="Observaciones"
                                    value={nuevoEgreso.observaciones}
                                    onChange={(e) => setNuevoEgreso({ ...nuevoEgreso, observaciones: e.target.value })}
                                    fullWidth
                                    multiline
                                    minRows={3}
                                    sx={InputDescripcion}
                                />

                            </Box>
                        </Box>
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button sx={buttonCancelar} onClick={() => setOpenCrear(false)}>
                        Cancelar
                    </Button>

                    <Button sx={buttonGuardar} onClick={handleCrearEgreso}>
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>

            <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: "center" }}>
                        <FaRegCircleCheck style={{ color: "green", fontSize: "2rem" }} />
                        <p className="alert-text">{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: "center" }}>
                        <BiErrorCircle style={{ color: "red", fontSize: "2rem" }} />
                        <p className="alert-text">{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            <Modal open={enviandoAlert}>
                <Box sx={modalStyle}>
                    <section style={{ textAlign: "center", padding: "1rem" }}>
                        <CircularProgress style={{ color: "#2a8d74" }} />
                        <p className="alert-text">Procesando solicitud...</p>
                    </section>
                </Box>
            </Modal>
            <Modal open={openAdvertencia} onClose={() => setOpenAdvertencia(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setOpenAdvertencia(false)}>
                        <IoClose />
                    </section>

                    <section style={{ textAlign: "center" }}>
                        <BiErrorCircle style={{ color: "#E0A800", fontSize: "3rem" }} /> {/* amarillo advertencia */}
                        <Typography
                            sx={{
                                fontFamily: "Poppins",
                                fontSize: "1rem",
                                mt: 2,
                                fontWeight: 500,
                            }}
                        >
                            Debes crear categorías de egresos antes de crear un egreso.
                        </Typography>

                        <Button
                            variant="contained"
                            sx={{
                                mt: 3,
                                backgroundColor: "#E0A800",
                                color: "#fff",
                                borderRadius: "50px",
                                textTransform: "none",
                                fontFamily: "Poppins",
                            }}
                            onClick={() => setOpenAdvertencia(false)}
                        >
                            Entendido
                        </Button>
                    </section>
                </Box>
            </Modal>

            <Dialog
                open={openDialogExcel}
                onClose={() => setOpenDialogExcel(false)}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle sx={{ fontFamily: "Poppins", textAlign: "center" }}>
                    Descargar Egresos
                </DialogTitle>

                <DialogContent dividers sx={{ p: 3 }}>

                    {/* Selección de Mes */}
                    <TextField
                        sx={Input}
                        select
                        label="Mes"
                        fullWidth
                        margin="normal"
                        value={filtroMes}
                        onChange={(e) => setFiltroMes(e.target.value)}
                    >
                        <MenuItem value="">Todos</MenuItem>

                        {[
                            { value: "1", label: "Enero" },
                            { value: "2", label: "Febrero" },
                            { value: "3", label: "Marzo" },
                            { value: "4", label: "Abril" },
                            { value: "5", label: "Mayo" },
                            { value: "6", label: "Junio" },
                            { value: "7", label: "Julio" },
                            { value: "8", label: "Agosto" },
                            { value: "9", label: "Septiembre" },
                            { value: "10", label: "Octubre" },
                            { value: "11", label: "Noviembre" },
                            { value: "12", label: "Diciembre" },
                        ].map((mes) => (
                            <MenuItem key={mes.value} value={mes.value}>
                                {mes.label}
                            </MenuItem>
                        ))}
                    </TextField>


                    {/* Selección de Año */}
                    <TextField
                        select
                        label="Año"
                        fullWidth
                        margin="normal"
                        sx={Input}
                        value={filtroAnio}
                        onChange={(e) => setFiltroAnio(e.target.value)}
                    >
                        <MenuItem value="">Todos</MenuItem>
                        {["2025", "2026", "2027"].map((a) => (
                            <MenuItem key={a} value={a}>{a}</MenuItem>
                        ))}
                    </TextField>

                    {/* Selección Sucursal */}
                    <TextField
                        select
                        label="Sucursal"
                        fullWidth
                        margin="normal"
                        sx={Input}
                        value={filtroSucursal}
                        onChange={(e) => setFiltroSucursal(e.target.value)}
                    >
                        <MenuItem value="">Todas</MenuItem>
                        {sucursales.map((s) => (
                            <MenuItem key={s.id} value={s.id.toString()}>
                                {s.name}
                            </MenuItem>
                        ))}
                    </TextField>

                </DialogContent>

                <DialogActions sx={{ p: 2 }}>
                    <Button
                        sx={{ ...buttonCancelar, textTransform: "none" }}
                        onClick={() => setOpenDialogExcel(false)}
                    >
                        Cancelar
                    </Button>

                   <Button
    variant="contained"
    sx={buttonGuardar}
    onClick={handleDescargarExcel}
>
    Descargar Excel
</Button>
                </DialogActions>
            </Dialog>

        </Container>
    )
}